// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Space, Row, Col } from "antd";
import { fetchCategory, getCategories } from "~/redux/actions/app";
import { fetchPostList } from "~/redux/actions/post";

// views
import SiteLayout from "~/components/layout/SiteLayout";
import AppMobileNav from "~/components/app/AppMobileNav";
import NewPostCard from "~/components/sider/NewPostCard";
import CategoryNavs from "~/components/header/CategoryNavs";
import CategoryTagNavs from "~/components/header/CategoryTagNavs";
import SiteBanner from "~/components/site/SiteBanner";
import SiderPrimary from "~/components/sider/SiderPrimary";
import AppSearch from "~/components/app/AppSearch";
import PostList from "~/components/post/PostList";
import CategoryCard from "~/components/sider/CategoryCard";
import TalentInfoCard from "~/components/sider/TalentInfoCard";

// utils
import _ from "lodash";
import { getCookie } from "~/utils/cookie";
import { decodeTags } from '~/utils/post'
import { extractDescriptionForPostList } from "~/utils/seo";
import settings from "~/settings"

const CategoryHomePage = (props) => {
  const { category, categories, postList, tags } = props;

  return (
    <SiteLayout
      pageTitle={category.name}
      pageSider={(
        <div>
          <NewPostCard category={category} />
          <CategoryCard category={category} />
          {props.token && category.code === "talent" && (
            <TalentInfoCard />
          )}
          <SiderPrimary />
        </div>
      )}
      description={extractDescriptionForPostList(postList.posts)}
    >
      <Row>
        <Col xs={24} sm={24} md={0}>
          <AppMobileNav />
          <NewPostCard category={category} />
          <AppSearch />
        </Col> 
      </Row>

      <SiteBanner />

      <Card>
        <Space direction="vertical" size={12} style={{ display: "flex" }}>
          <CategoryNavs categories={categories} selected={category.id} />
          <CategoryTagNavs category={category} />
        </Space>
      </Card>

      <PostList postList={postList} sort={props.sort} />
    </SiteLayout>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user.user,
  categories: state.app.categories.filter(x => !x.paid),
});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

CategoryHomePage.requireUser = () => false;

CategoryHomePage.getInitialProps = async (ctx) => {
  const { query } = ctx;
  const state = ctx.store.getState();

  // 加载首页的所有版块

  if (!state.app.categories.length) {
    await ctx.store.dispatch(getCategories());
  }
  const categories = state.app.categories.filter(x => !x.paid);
  const category = await fetchCategory(query.category);

  // 加载首页的帖子列表
  const tags = decodeTags(query.tags);
  const cookieSort = getCookie("sort", ctx.req);
  const sort = query.sort || cookieSort;
  const page = parseInt(query.page) || 1;
  const postList = await fetchPostList({ sort, page, tags, category: query.category });

  return {
    category,
    categories,
    postList,
    tags,
    sort,
    page,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryHomePage);
